type CreateAgendaItemDataProps = {
    subject: string;

    start: string;

    end: string;

    description?: string;

    location?: string;

    attendees?: string[];

    isAllDay?: boolean;
};

export default class CreateAgendaItemData {
    subject: string;

    start: string;

    end: string;

    description?: string;

    location?: string;

    attendees?: string[];

    isAllDay?: boolean;

    constructor({
        subject,
        description,
        start,
        end,
        location,
        attendees,
        isAllDay,
    }: CreateAgendaItemDataProps) {
        this.subject = subject;
        this.description = description;
        this.start = start;
        this.end = end;
        this.location = location;
        this.attendees = attendees;
        this.isAllDay = isAllDay;
    }
}
